/* EVAMATS · akcesoria · konfigurator (szablon product.akcesoria-konfigurator)
   Nakłada wygląd głównego konfiguratora na wybór wariantu z motywu (variant-radios).
   Niczego nie podmienia w logice: koszyk, cenę, zmianę zdjęcia i dostępność robi motyw.
   Kolor opcji to zwykła pastylka w kolorze nazwy (tabela nazw kolorów PL/EN poniżej, nic pod konkretny produkt);
   opcje, które nie są kolorami (rozmiar, zestaw), zostają zwykłymi przyciskami. */
(() => {
  'use strict';
  const dataEl = document.querySelector('[data-acc-data]');
  if (!dataEl) return;
  let data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  const strings = data.strings || {};
  const h = (tag, cls) => { const e = document.createElement(tag); if (cls) e.className = cls; return e; };

  // Nazwa koloru -> kolor. Kolejność ma znaczenie: odcienie (ciemnoszary) przed ogólnymi (szary); dopasowany fragment jest wycinany,
  // więc „ciemnoszary” nie daje drugiego trafienia „szary”. Dwie nazwy w jednej wartości („czarny, szew czerwony”) dają dwukolorową pastylkę.
  const COLOURS = [
    [/ciemno\s*szar|dark\s*gr[ae]y|grafit|anthracite|antracyt/, '#4f5359'],
    [/jasno\s*szar|light\s*gr[ae]y/, '#c4c7cc'],
    [/szar|gr[ae]y/, '#8d9096'],
    [/ciemno\s*be[żz]|dark\s*beige/, '#a58c62'],
    [/jasno\s*be[żz]|light\s*beige|kremow|cream/, '#eadfc8'],
    [/be[żz]|beige|piask|\bsand\b/, '#d6c3a0'],
    [/kawow|coffee|czekolad|chocolate/, '#6a4b38'],
    [/br[ąa]z|brown/, '#7a5238'],
    [/granat|navy/, '#1d2c52'],
    [/ciemno\s*niebiesk|dark\s*blue/, '#1f4f99'],
    [/jasno\s*niebiesk|light\s*blue|b[łl][ęe]kit|sky\s*blue/, '#8ec1ea'],
    [/turkus|turquoise|teal/, '#2aa6a0'],
    [/niebiesk|blue/, '#3f86d6'],
    [/bordow|burgund|wine|maroon|malinow/, '#6d1b2c'],
    [/czerwon|\bred\b/, '#d3182b'],
    [/pomara[ńn]cz|orange/, '#f08a24'],
    [/[żz][óo][łl]t|yellow/, '#f2c41d'],
    [/ziel|green/, '#2f8a4f'],
    [/fiolet|purple|violet/, '#6c4aa5'],
    [/r[óo][żz]ow|pink/, '#e86aa6'],
    [/z[łl]ot|gold/, '#c9a23f'],
    [/srebrn|silver/, '#bfc3c9'],
    [/miedzi|copper/, '#b46a3c'],
    [/ko[śs][ćc]\s*s[łl]oniow|ivory/, '#efe7d2'],
    [/bia[łl]|white/, '#f5f5f3'],
    [/czarn|black/, '#18181a'],
  ];
  function resolveColour(name) {
    let s = String(name || '').toLowerCase();
    const found = [];
    COLOURS.forEach(([re, hex]) => {
      const m = re.exec(s);
      if (!m) return;
      found.push([m.index, hex]);
      s = s.slice(0, m.index) + ' '.repeat(m[0].length) + s.slice(m.index + m[0].length);
    });
    if (!found.length) return null;
    found.sort((a, b) => a[0] - b[0]);
    const hexes = found.map((f) => f[1]).filter((x, i, a) => a.indexOf(x) === i).slice(0, 2);
    return hexes.length === 2 ? 'linear-gradient(135deg,' + hexes[0] + ' 50%,' + hexes[1] + ' 50%)' : hexes[0];
  }

  function buildSwatch(label, input, colour) {
    const hidden = label.querySelector('.visually-hidden');
    label.textContent = '';
    label.classList.add('acc-tile');
    const sw = h('span', 'acc-sw');
    sw.style.background = colour;
    sw.setAttribute('aria-hidden', 'true');
    const name = h('span', 'acc-name__text');
    name.textContent = input.value;
    const sold = h('span', 'acc-sold');
    sold.textContent = strings.soldOut || '';
    label.append(sw, name, sold);
    if (hidden) label.append(hidden);
  }

  function enhanceFieldset(fs) {
    const inputs = Array.from(fs.querySelectorAll('input[type="radio"]'));
    if (!inputs.length) return;
    const colours = inputs.map((i) => resolveColour(i.value));
    // pastylki kolorów tylko wtedy, gdy KAŻDA wartość opcji jest rozpoznanym kolorem; inaczej zwykłe przyciski
    const swatches = colours.every(Boolean);
    const legend = fs.querySelector('legend');
    const wrap = h('div', 'acc-options ' + (swatches ? 'acc-options--tiles' : 'acc-options--chips'));
    fs.insertBefore(wrap, legend ? legend.nextSibling : fs.firstChild);
    inputs.forEach((input, i) => {
      const label = fs.querySelector('label[for="' + input.id + '"]');
      wrap.append(input);
      if (!label) return;
      wrap.append(label);
      if (swatches) buildSwatch(label, input, colours[i]);
      else label.classList.add('acc-chip');
    });
    const pill = fs.querySelector('.lip__title_value');
    const sync = () => {
      const on = inputs.find((i) => i.checked);
      if (pill && on) pill.textContent = on.value;
    };
    fs.addEventListener('change', () => setTimeout(sync, 0));
    sync(); setTimeout(sync, 400);
  }

  // Tytuł, ocena i cena w jednej ciemnej karcie, reszta (opcje, uwagi, przycisk) w białej. Węzły tylko się przenoszą,
  // identyfikatory zostają, więc skrypty motywu znajdują je tak samo jak wcześniej. Rozwijany opis („Opis”) wychodzi z białej karty
  // pod nią, bo jest zrobiony pod ciemne tło (w białej karcie był niewidoczny i wyglądał jak pusty pas pod przyciskiem).
  function restructure(info) {
    const direct = (sel) => Array.from(info.children).find((c) => c.matches(sel));
    const parts = ['.product__title', '.product__message', '.rating', '[id^="price-"]', '.product__tax'].map(direct).filter(Boolean);
    if (!parts.length) return;
    const head = h('div', 'acc-head');
    info.insertBefore(head, parts[0]);
    if (data.type) {
      const k = h('div', 'acc-kicker');
      k.textContent = data.type;
      head.append(k);
    }
    parts.forEach((p) => head.append(p));
    const card = h('div', 'acc-card');
    head.after(card);
    Array.from(info.children).forEach((c) => { if (c !== head && c !== card) card.append(c); });
    Array.from(card.children).filter((c) => c.matches('details.details_accordion')).reverse().forEach((d) => { d.classList.add('acc-after-card'); card.after(d); });
  }

  // Strzałki na zdjęciu + przeciąganie myszą (komputer). Klikają te same przyciski miniatur, których używa motyw, więc cała logika
  // przełączania zdjęć zostaje po stronie motywu; na telefonie działa zwykłe przesuwanie palcem.
  function enhanceGallery() {
    const wrap = document.querySelector('.product-media-gallery-wr');
    if (!wrap) return;
    const prevBtn = wrap.querySelector('.thumbnail-slider .slider-button--prev');
    const nextBtn = wrap.querySelector('.thumbnail-slider .slider-button--next');
    const stage = wrap.querySelector('slider-component[id^="GalleryViewer"]');
    if (!prevBtn || !nextBtn || !stage) return;
    if (wrap.querySelectorAll('li.product__media-item').length < 2) return;
    stage.classList.add('acc-gal-stage');
    const arrow = (dir, label, target, d) => {
      const b = h('button', 'acc-gal-arrow acc-gal-arrow--' + dir);
      b.type = 'button';
      b.setAttribute('aria-label', label);
      b.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path d="' + d + '" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      b.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); target.click(); });
      return b;
    };
    const lang = (document.documentElement.lang || '').toLowerCase().startsWith('en');
    const pb = arrow('prev', lang ? 'Previous photo' : 'Poprzednie zdjęcie', prevBtn, 'M15 5l-7 7 7 7');
    const nb = arrow('next', lang ? 'Next photo' : 'Następne zdjęcie', nextBtn, 'M9 5l7 7-7 7');
    stage.append(pb, nb);
    const sync = () => { pb.disabled = prevBtn.disabled || prevBtn.hasAttribute('disabled'); nb.disabled = nextBtn.disabled || nextBtn.hasAttribute('disabled'); };
    sync();
    new MutationObserver(sync).observe(wrap.querySelector('.thumbnail-slider'), { subtree: true, attributes: true, attributeFilter: ['disabled', 'class'] });
    // przeciąganie myszą: wystarczy 50 px w bok
    let x0 = null, moved = false;
    stage.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse' || e.button !== 0 || e.target.closest('.acc-gal-arrow')) return; x0 = e.clientX; moved = false; });
    window.addEventListener('pointermove', (e) => { if (x0 === null) return; if (Math.abs(e.clientX - x0) > 8) { moved = true; stage.classList.add('is-dragging'); } });
    window.addEventListener('pointerup', (e) => {
      if (x0 === null) return;
      const dx = e.clientX - x0; x0 = null; stage.classList.remove('is-dragging');
      if (moved && Math.abs(dx) > 50) (dx < 0 ? nextBtn : prevBtn).click();
    });
    stage.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    stage.addEventListener('dragstart', (e) => e.preventDefault());
  }

  function init() {
    const info = document.querySelector('product-info');
    if (!info) return;
    try { restructure(info); } catch (e) { /* zostaje domyślny układ motywu */ }
    info.querySelectorAll('variant-radios fieldset[data-option-position]').forEach((fs) => {
      try { enhanceFieldset(fs); } catch (e) { /* zostają zwykłe przyciski motywu */ }
    });
    // Motyw na domyślnym szablonie pozwala wybrać także wyprzedany kolor (przycisk pokazuje „Wyprzedane”); flaga jest zależna od pustego szablonu,
    // więc po przejściu na ten szablon ustawiamy ją sami, żeby zachowanie zostało takie samo.
    const vr = info.querySelector('variant-radios');
    if (vr && !vr.closest('.config_container')) vr.dataset.allowSoldoutSelect = 'true';
    try { enhanceGallery(); } catch (e) { /* zostają strzałki pod zdjęciem */ }
    document.documentElement.classList.add('acc-cfg-ready');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
